export const translations = {
  title: {
    pt: 'Adicionar paradas',
    en: 'Add stops',
    es: 'Agregar paradas',
    de: 'Stopps hinzufügen',
  },
  subtitle: {
    pt: 'Você pode adicionar paradas entre a origem e destino da rota.',
    en: 'You can add stops between the origin and destination of the route.',
    es: 'Puedes agregar paradas entre el origen y el destino de la ruta.',
    de: 'Sie können Stopps zwischen dem Start- und Zielpunkt der Route hinzufügen.',
  },
  stopUf: {
    pt: 'UF da parada',
    en: 'Stop UF',
    es: 'UF de la parada',
    de: 'UF des Stopps',
  },
  stopIbge: {
    pt: 'Cidade da parada',
    en: 'Stop city',
    es: 'Ciudad de la parada',
    de: 'Stadt des Stopps',
  },
  stopLatitude: {
    pt: 'Latitude da parada',
    en: 'Stop latitude',
    es: 'Latitud de la parada',
    de: 'Breitengrad des Stopps',
  },
  stopLongitude: {
    pt: 'Longitude da parada',
    en: 'Stop longitude',
    es: 'Longitud de la parada',
    de: 'Längengrad des Stopps',
  },
  submitButton: {
    pt: 'Adicionar',
    en: 'Add',
    es: 'Agregar',
    de: 'Hinzufügen',
  },
};